export var gardenFormUtil = {
    hideErrors: function () {
        $('.js-garden-image-error').addClass('hidden').removeClass('warning-text-orange');
    },
    showGenericError: function () {
        $('.js-garden-image-error').text('Något gick fel med filuppladdningen, försök igen, eller testa en annan bild.').removeClass('hidden');
    },
    showError: function (text, warning) {
        if (warning === void 0) { warning = false; }
        $('.js-garden-image-error').text(text).removeClass('hidden');
        if (warning) {
            $('.js-garden-image-error').addClass('warning-text-orange');
        }
    },
    enableUploadBtn: function () {
        $('.js-garden-upload-btn').prop('disabled', false);
    },
    disableUploadBtn: function () {
        $('.js-garden-upload-btn').prop('disabled', true);
    }
};
